import { useEffect, useState } from "react";
import { WhatsNew } from "@/common/model/WhatsNew";
import { WhatsNewService } from "@/services/WhatsNewService";
import WhatsNewManager from "@/components/whatsnew/WhatsNewManager";

const WhatsNewPage = () => {
  const [whatsNewItems, setWhatsNewItems] = useState<WhatsNew[]>([]);
  const [selectedTab, setSelectedTab] = useState("active");

  useEffect(() => {
    const fetchWhatsNewItems = async () => {
      const response = await WhatsNewService.fetchAll();
      let filteredItems = response;
      if (selectedTab !== "all") {
        filteredItems = filteredItems.filter(
          (item) => item.status === selectedTab
        );
      }
      setWhatsNewItems(filteredItems);
    };
    fetchWhatsNewItems();
  }, [selectedTab]);

  const handleTabSelect = (tab: string) => {
    setSelectedTab(tab);
  };

  return (
    <WhatsNewManager
      selectedTab={selectedTab}
      onSelectTab={(tab: string) => handleTabSelect(tab)}
      whatsNewItems={whatsNewItems}
      setWhatsNewItems={setWhatsNewItems}
    />
  );
};

export default WhatsNewPage;
